import React, { useEffect, useState } from 'react';

import { Container, Row, Col, Form, FormGroup, Input, Label, Button, InputGroup, InputGroupAddon, InputGroupText, NavItem, NavLink, Nav, TabContent, TabPane, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap'
import { sendRequest } from '../../hooks/requests/useRequest';
import { useForm } from '../../hooks/forms/useForm';
import { classes } from '../../data/layouts';
import '../../index.scss';
import { useSweetAlert } from '../../hooks/sweetAlerts/useSweetAlert';
import jwt_decode from "jwt-decode";
import './StyleMicrositeCompany.css';
import Select from 'react-select';
import { cedimi, demo, insan } from '../../constant/globalConstantsTypeClients';
import { ConfigServer } from '../../data/config'



const LoginMicrosite = (props) => {
    const [loading, setLoading] = useState(false);
    const defaultLayoutObj = classes.find(item => Object.values(item).pop(1) === 'compact-wrapper');
    const layout = localStorage.getItem('layout') || Object.keys(defaultLayoutObj).pop();


    const [loged, setLoged] = useState(false);
    const jwt_token = localStorage.getItem('token');
    const empresa = localStorage.getItem('empresa');
    const id_company = localStorage.getItem('id_company');
    const [createSweet] = useSweetAlert();





    useEffect(() => {
        if (loged === true) {
            //    let pruebas = `${process.env.PUBLIC_URL}`
            window.location.href = `${process.env.PUBLIC_URL}`;
            ////console.log('pasa? ', pruebas);
        }
    }, [loged]);


    const [formValues, handleInputChange, reset, handleUpdateValues, handleSelectValues] = useForm({
        userName: "",
        password: "",
        userType: { value: 1, label: "EMPRESAS" },
    });

    

    const [validationsLogin, setValidationsLogin] = useState({
        userName: false,
        userType: false,
        password: false,

    });

    const { userName, password, userType } = formValues;
    const [showText, setShowText] = useState(false);


    const [userTypes, setUserTypes] = useState([
        {
            value: 1,
            label: "EMPRESAS"
        },
        {
            value: 2,
            label: "MÉDICOS"
        }
    ]);
    const [submitLogin, setSubmitLogin] = useState(false);



    const iniciarSesion = async (e) => {
        e.preventDefault();
        setSubmitLogin(true);

        setShowText(false);
        setLoading(true);


        if (!validationLogin()) {
            setLoading(false);
            return;
        }

        let id = formValues.userType

        let _copy =
        {
            "userName": formValues.userName,
            "password": formValues.password,
            "userType": id.value,
        }

        let raw = JSON.stringify(_copy);

        let requestOptions = {
            method: 'POST',
            body: raw,

        };
        const respuesta = await sendRequest(requestOptions, "Company/LoginMicrosite");
        console.log("🚀 ~ iniciarSesion ~ respuesta:", respuesta)

        if (respuesta.code === 200) {


            ////console.log("pasa2");

            setLoading(false)

            ////console.log(respuesta.data);

            let { Name, Username, Empresa, IdCompany } = jwt_decode(respuesta.data.token);
            localStorage.setItem("token", respuesta.data.token);
            localStorage.setItem("companyName", Name);
            localStorage.setItem("nameUser", Username);
            localStorage.setItem("empresa", Empresa);
            localStorage.setItem("id_company", respuesta.data.id_company);
            localStorage.setItem("userType", respuesta.data.userType);
            localStorage.setItem("url_helen", respuesta.data.url_helen);
            localStorage.setItem("id_agreement", respuesta.data.id_agreement);


            setLoged(true);
        }
        else {
            setLoading(false)

            ////console.log("pasa");
            createSweet("error", "error", respuesta.data.msg);



        }
    }

    const validationLogin = () => {
        let newValidations = {
            userName: true,
            password: true,
            userType: true,
        };

        let isValid = true;

        if (!formValues.userName || formValues.userName.trim() === "") {
            newValidations.userName = false;
            isValid = false;
        }

        if (!formValues.password || formValues.password.trim() === "") {
            newValidations.password = false;
            isValid = false;
        }

        if (!formValues.userType || !formValues.userType.value) {
            newValidations.userType = false;
            isValid = false;
        }

        setValidationsLogin(newValidations);
        return isValid;
    };


    useEffect(() => {

        if (jwt_token !== null && empresa !== null) {
            props.history.replace(`${process.env.PUBLIC_URL}/dashboard/defaultMicrositio`);
        }
    }, [props.history])

    const getDefaultImage = (type) => {
        if (type === 1)
            return require('../../assets/images/microsite/companyGlobal.jpg');

        if (type === 2)
            return require('../../assets/images/microsite/doctors.jpg');

        return require('../../assets/images/microsite/login.jpg');
    };

    // const [imageSrc, setImageSrc] = useState(getDefaultImage());
    const [imageSrc, setImageSrc] = useState(
        require('../../assets/images/microsite/companyGlobal.jpg')
    );


    const [showPassword, setShowPassword] = useState(false);


    let _url_helen = localStorage.getItem('url_helen');

   
   useEffect(() => {

        if (!userType?.value) {
            setImageSrc(getDefaultImage());
            return;
        }

        const serverImage =
            userType.value === 1
                ? `${ConfigServer.serverUrl}/api/Microsite/GetLoginMicrositeImage?type=company`
                : `${ConfigServer.serverUrl}/api/Microsite/GetLoginMicrositeImage?type=doctor`;

        const img = new Image();
        img.src = serverImage;

        img.onload = () => {
            setImageSrc(serverImage);
        };

        img.onerror = () => {
            setImageSrc(getDefaultImage(userType.value));
        };

    }, [userType]);

    useEffect(() => {
        const company = new Image();
        company.src = `${ConfigServer.serverUrl}/api/Microsite/GetLoginMicrositeImage?type=company`;

        const doctor = new Image();
        doctor.src = `${ConfigServer.serverUrl}/api/Microsite/GetLoginMicrositeImage?type=doctor`;
    }, []);

    return (
        <Container fluid className="d-flex align-items-center justify-content-center" style={{ minHeight: "100vh", position: "relative", overflow: "hidden" }}>
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backdropFilter: "blur(40px)",
                    WebkitBackdropFilter: "blur(40px)",
                    background: `
                    linear-gradient(
                        to bottom,
                        rgba(161, 201, 221, 0.95) 0%,
                        rgba(133, 202, 236, 0.75) 35%,
                        rgba(87, 212, 250, 0.65) 65%,
                        rgba(17, 125, 212, 0.9) 100%
                    )
                    `,
                }}
            />
            <Row className="w-100 justify-content-center align-items-center">

                <Col xs="12" md="10" lg="9" xl="8">
                    <div className="d-flex flex-column flex-md-row"
                        style={{
                            background: "rgba(243, 243, 243, 0.63)",
                            backdropFilter: "blur(18px) saturate(160%)",
                            WebkitBackdropFilter: "blur(18px) saturate(160%)",
                            borderRadius: "24px",
                            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.13)",
                            padding: "1rem",
                            minHeight: "550px",
                            alignItems: "stretch"
                        }}
                    >
                        <div
                            style={{
                                flex: 1.5,
                                display: "flex",
                                borderRadius: "15px",
                                overflow: "hidden",
                                alignItems: "stretch",
                                backgroundColor: "#f3f3f3"
                            }}
                        >
                            {/* <img
                                src={imageSrc}
                                alt="Login Microsite"
                                className='img-fade'
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                    objectPosition: "top center",
                                    display: "block"
                                }}
                            /> */}
                            <div
                            style={{
                                width: "100%",
                                height: "100%",
                                backgroundImage: `url(${imageSrc})`,
                                backgroundSize: "cover",
                                backgroundPosition: "center",
                                backgroundRepeat: "no-repeat"
                            }}
                            />
                        </div>

                        <div
                            style={{
                                flex: 1,
                                padding: "2rem 1.5rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                minWidth: "300px"
                            }}
                        >
                            <div className="text-center mb-4">
                                <span style={{ fontSize: "17px", fontWeight: "600", color: "#023047", letterSpacing: "1px" }}>
                                    Micrositio de resultados
                                </span>
                                <div style={{ width: "60px", height: "2px", background: "linear-gradient(90deg, #063d5e, #147287)", margin: "6px auto 0", borderRadius: "2px" }} />
                            </div>

                            <div className="text-center">
                                {_url_helen !== insan && (
                                    <img
                                        src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                        alt="cedimiLogo"
                                        style={{ width: "130px", marginBottom: "1rem" }}
                                    />
                                )}
                                <Form className="theme-form text-center" onSubmit={iniciarSesion}>
                                    <div className="mx-auto" style={{ maxWidth: "100%" }}>
                                        <FormGroup>
                                            <Label>Tipo de usuario</Label>
                                            <Select
                                                name="userType"
                                                options={userTypes}
                                                value={userType}
                                                onChange={(e) => handleSelectValues(e, 'userType')}
                                                isClearable={false}
                                            />
                                            {submitLogin && !validationsLogin.userType && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                                                    <i className="fa fa-exclamation-circle mr-2" />Seleccione un tipo de usuario
                                                </div>
                                            )}
                                        </FormGroup>

                                        {/* user */}
                                        <FormGroup>
                                            <Label>Usuario</Label>
                                            <Input
                                                type="text"
                                                name="userName"
                                                value={userName}
                                                onChange={handleInputChange}
                                                className="form-control-sm input-air-primary btn-pill"
                                                style={{ border: "#0079C7 2px solid" }}
                                            />
                                            {submitLogin && !validationsLogin.userName && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                                                    <i className="fa fa-exclamation-circle mr-2" />Ingrese un usuario
                                                </div>
                                            )}
                                        </FormGroup>

                                        {/* password */}
                                        <FormGroup>
                                            <Label>Contraseña</Label>
                                            <InputGroup>
                                                <Input
                                                    type={showPassword ? 'text' : 'password'}
                                                    name="password"
                                                    value={password}
                                                    onChange={handleInputChange}
                                                    className="form-control-sm input-air-primary btn-pill"
                                                    style={{ border: "#0079C7 2px solid" }}
                                                    placeholder="Contraseña"
                                                />
                                                <InputGroupAddon addonType="append">
                                                    <InputGroupText>
                                                        <span
                                                            className={`fa fa-eye${showPassword ? '-slash' : ''}`}
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            style={{ cursor: 'pointer' }}
                                                        />
                                                    </InputGroupText>
                                                </InputGroupAddon>
                                            </InputGroup>
                                            {submitLogin && !validationsLogin.password && (
                                                <div className="text-danger mt-1" style={{ fontSize: '0.9rem' }}>
                                                    <i className="fa fa-exclamation-circle mr-2" />Ingrese una contraseña
                                                </div>
                                            )}
                                        </FormGroup>
                                        <br />
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="btn-pill w-100"
                                            disabled={loading}
                                        >
                                            {loading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true" />
                                                    Cargando...
                                                </>
                                            ) : (
                                                "Iniciar sesión"
                                            )}
                                        </Button>

                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    );
};


export default LoginMicrosite;


